import angular from 'angular';
import s from './step2Step3Ctrl.module.css';
import sButton from '../../components/ReturnsButton/returnsButton.module.css';
import {
  setSelectedOption,
  clearSelectedOptions,
  removeSelectedOption,
  setDefaultOptions,
} from '../../actions/options';
import { getCurrentStepFromUrl } from '../../lib/url';
import {
  updateStep2Complete,
  updateGiftFlag,
  getRedirectUrlPath,
  updateGiftEmail,
  setLoading,
  setShowAddressOnStep3,
} from '../../actions/page';
import {
  receiveShippingAddress,
  setShippingAddressValidation,
  validateAddress,
  receiveNotificationMessage,
  setIsValidAddress,
} from '../../actions/addresses';
import { getRefundEstimation, selectRefundOption } from '../../actions/refunds';
import { updatePaymentAmount, receivePaymentAuthorization } from '../../actions/payments';
import patternInputValidation from '../../lib/patternInputValidation';
import { isAddressValid } from '../../lib/addresses';
import { EMAIL_ADDRESS_PATTERN } from '../../constants/validationPatterns';
import { PICKUP, LOCAL_PICKUP, METHODS_WITHOUT_ADDRESS } from '../../constants/returnMethods';
import DEFAULT_COPY from '../../constants/defaultCopy';
import { PICKUP_COMPLETE } from '../../constants/broadcastEvents';
import generateMethodKey from '../../lib/generateMethodKey';
import mapToCorrectShippingAddress from '../../components/ReturnMethodSidebar/lib/mapToCorrectShippingAddress';
import { saveUserPreferences } from '../../actions/userPreferences';
import { EMAIL_MISMATCH } from '../../constants/preferences';
import { retailerSettingsService } from '../../services/retailer-settings/retailer-settings';
import { orderService } from '../../services/order-service/order-service';
import { returnItemsService } from '../../services/return-items-service/return-items-service';
import { hasMultiOrder } from '../../react-components/AdditionalOrderForm/utils';
import { a11yPageRedirection } from '../../lib/a11yUtils';
import { returnFeeService } from '../../services/return-fee/return-fee';
import { currencyService } from '../../services/currency-service/currency-service';
import { postReturnService } from '../../services/return-post/return-post';
import { toggleTooltip } from '../../actions/tooltip';
import { store } from '../../store';
import { blindReturnSidebarService } from '../../services/blind-return-sidebar-service';
import { returnMethodSidebar } from '../../services/return-method-sidebar-service';
import { returnReasonSidebar, exchangeSidebar } from '../../services';
import { processReturnExchange, submitCart } from '../../lib/submitCart';
import { ActionTypes } from '../../constants/enums';
import { receiveReturnSubmission } from '../../actions/returnSubmission';
import {
  calculateCart,
  createDraftOrder,
  receiveUnevenExchangePaymentAuth,
} from '../../actions/unevenExchanges';
import { extendOrder } from '../../services/order-service/extendOrder';
import { ERRORS_WITH_CUSTOM_MESSAGES } from '../../constants/errorCodes';

angular.module('Step2Step3Ctrl', []).controller('Step2Step3Controller', [
  '$rootScope',
  '$scope',
  '$location',
  '$filter',
  '$anchorScroll',
  ($rootScope, $scope, $location, $filter, $anchorScroll) => {
    const {
      page: { productType, bypassSteps },
      claims: { enabled: claimsEnabled } = {},
      returnsSettings: {
        [productType]: {
          displayFormIfExchangeIncluded,
          refund_option: {
            enabled: refundOptionEnabled = false,
            options: refundOptionsList = [],
          } = {},
          refunds: {
            enable_api: refundApiEnabled = false,
            allow_only_positive_refunds: allowOnlyPositiveRefunds = false,
          } = {},
          agreement_checkbox: agreementCheckbox,
          agreement_checkbox: {
            enabled: agreementCheckboxEnabled = false,
            options: agreementCheckboxOptions = [],
          } = {},
          returnOptions: {
            enabled: returnOptionsEnabled = false,
            methods: returnOptionsMethods = {},
          } = {},
          disableGiftAddressForm = false,
          attestation,
          exchange: { unevenExchanges } = {},
        } = {},
      },
    } = store.getState();

    const updateStoreState = () => {
      const {
        addresses: {
          shipTo,
          shippingAddress,
          isShippingAddressValid,
          defaultAddressKey,
          [defaultAddressKey]: defaultAddress,
        },
        language,
        page: { locale, languageCode, step2Complete, giftOrder = false, giftEmail } = {},
        options: { selectedOptions: newSelectedOptions, unSelectedKeys: newUnSelectedKeys },
        returnOptions: {
          selectedOptionMethodKey,
          selectedOptionId,
          returnOptionMethods,
          returnOptionMethods: {
            [selectedOptionMethodKey]: { return_cost: { service_fee: serviceFee } = {} } = {},
          } = {},
        } = {},
        storeLocator: { selectedLocation, country: storeLocatorCountryCode, isConsolidated },
        refunds: {
          refundEligibility,
          selectedType,
          itemizationsByType: {
            [selectedType]: { estimated_refund: { value: estimatesApiRefundAmount } = {} } = {},
          } = {},
          noRefundSelected,
        } = {},
        localPickup: {
          date: localPickupDate,
          selectedTimeslot: { value: localPickupTime } = {},
          instructions: localPickupInstructions,
          slotId: localPickupSlotId,
        } = {},
        returnMethods: { selectedMethod, selectedMethodKey, returnMethods } = {},
        payments: {
          enabled: paymentsEnabled,
          paymentAuthorization,
          formattedAmountDue = '',
          paymentApiKey = '',
          amountDue = 0,
        } = {},
        carrierPickup: { date: pickupDate },
        returnSubmission: {
          errors: { error_message_detail_code: errorCode = null } = {},
          attestation: attestationData,
        } = {},
        stripe: { service: stripeService, completedPayment, narvarPaymentId, fee: stripeFee } = {},
        pickup: { form: pickupForm },
        carrierPickup: {
          date: carrierPickupDate,
          timeWindow: carrierPickupTimeWindow,
          address: carrierPickupAddress,
          timeZone: carrierPickupTimeZone,
        } = {},
        userPreferences: {
          isSigningUp: userPrefIsSigningUp,
          isSaving: userPrefIsSaving,
          validForm: userPrefValidForm,
          skipEmailInput: userPrefSkipEmailInput,
        } = {},
      } = store.getState();
      $scope.state = store.getState();
      $scope.lang = language;
      $scope.DEFAULT_LANG = DEFAULT_COPY[languageCode] || {};
      $scope.confirmOrder = orderService.getConfirmOrder();
      $scope.selectedOptions = newSelectedOptions;
      $scope.unSelectedKeys = newUnSelectedKeys;
      $scope.listSelectedOptions = newSelectedOptions;
      $scope.giftOrder = giftOrder;
      $scope.giftReturnsEmail = giftEmail;
      $scope.useGiftAddressSidebar = giftOrder && locale === 'en_US' && !returnOptionsEnabled;
      $scope.defaultAddress = defaultAddress;
      $scope.shippingAddress = shippingAddress;
      $scope.shipTo = shipTo;
      $scope.isShippingAddressEmpty = Object.keys(shippingAddress).length === 0;
      $scope.isShippingAddressValid = isShippingAddressValid;
      $scope.selectedType = selectedType;
      $scope.hasMultipleOrders = hasMultiOrder({ returnItems: returnItemsService.getItems() });
      $scope.refundOptionEnabled =
        refundOptionEnabled &&
        (!$scope.giftOrder || refundOptionsList.some(({ key }) => key === 'gift'));
      $scope.step2Complete = step2Complete;
      $scope.noRefundSelected = noRefundSelected;
      $scope.selectedReturnOptionMethod = returnOptionMethods[selectedOptionMethodKey];
      $scope.selectedStoreLocation = selectedLocation;
      $scope.storeLocatorCountryCode = storeLocatorCountryCode;
      $scope.refundApiEnabled = refundApiEnabled;
      $scope.refundEligibility = refundEligibility;
      $scope.refundEligibility =
        !returnFeeService.getEstimatedRefund() > 0 && allowOnlyPositiveRefunds
          ? false
          : $scope.refundEligibility;
      $scope.selectedMethod = selectedMethod;
      $scope.selectedMethodKey = selectedMethodKey;
      $scope.estimatesApiRefundAmount = estimatesApiRefundAmount;
      $scope.paymentsEnabled = paymentsEnabled;
      $scope.paymentApiKey = paymentApiKey;
      $scope.amountDue = amountDue;
      $scope.paymentAuthorization = paymentAuthorization;
      $scope.paymentFormDescription = (
        $scope.lang['returns.step_3.payment_form.text'] || ''
      ).replace('$payment_amount', formattedAmountDue);
      $scope.paymentSubmissionError =
        errorCode && errorCode.startsWith('payments.errors')
          ? $scope.lang[`returns.${errorCode}`] || $scope.lang['returns.payments.errors.general']
          : null;
      $scope.returnMethods = returnMethods;
      $scope.step3SubHeader = language[`returns.step_3.step_3_subheader_${selectedMethodKey}`];
      $scope.hideNextButton = serviceFee > 0 && !completedPayment;
      $scope.stripeService = stripeService;
      $scope.showStep3Payment = serviceFee > 0 && completedPayment;
      $scope.completedPayment = completedPayment;
      $scope.narvarPaymentId = narvarPaymentId;
      $scope.step3PaymentTitle =
        $scope.lang[`returns.step_3.${selectedOptionMethodKey}.payment_title`] ||
        $scope.lang['returns.step_3_payment_title'] ||
        $scope.DEFAULT_LANG['returns.step_3_payment_title'] ||
        '';
      $scope.step3PaymentSummaryKey =
        $scope.lang[`returns.step_3.${selectedOptionMethodKey}.payment_summary_key`] ||
        $scope.lang['returns.step_3_payment_summary_key'] ||
        $scope.DEFAULT_LANG['returns.step_3_payment_summary_key'] ||
        '';
      $scope.step3PaymentSummaryValue = currencyService.formatPrice(stripeFee);
      $scope.pickupDate = pickupDate;
      $scope.localPickupInstructions = localPickupInstructions;
      $scope.localPickupDate = localPickupDate;
      $scope.localPickupTime = localPickupTime;
      $scope.localPickupSlotId = localPickupSlotId;
      $scope.localPickupScheduled = selectedOptionId === LOCAL_PICKUP && $scope.localPickupTime;
      $scope.hasRefundDefaults =
        refundOptionEnabled && refundOptionsList.filter((o) => o.default).length > 0;
      if (refundApiEnabled || refundOptionEnabled) {
        retailerSettingsService.setRequiredConditions(
          'selected-refund',
          !('noRefundSelected' in $scope) ||
            $scope.noRefundSelected === false ||
            $scope.hasRefundDefaults,
        );
        if (returnItemsService.isExchangesOnly()) {
          retailerSettingsService.deleteRequiredCondition('selected-refund');
        }
      }
      if (allowOnlyPositiveRefunds && refundApiEnabled) {
        retailerSettingsService.setRequiredConditions(
          'positive-refund',
          estimatesApiRefundAmount > 0,
        );
      }
      retailerSettingsService.setRequiredConditions(
        'items-not-empty',
        returnItemsService.getTotalSelected() > 0,
      );
      $scope.isDisabledStep3 = !retailerSettingsService.areAllConditionsChecked(store);
      $scope.pickupForm = pickupForm;
      $scope.pickupScheduled = pickupForm && pickupForm.date;
      $scope.carrierPickupEnabled = selectedOptionId === PICKUP;
      $scope.carrierPickupDate = carrierPickupDate;
      $scope.carrierPickupTimeWindow = carrierPickupTimeWindow;
      $scope.carrierPickupTimeZone = carrierPickupTimeZone;
      $scope.carrierPickupAddress = carrierPickupAddress;
      $scope.isConsolidated = isConsolidated;
      $scope.collectGiftAddress = giftOrder && locale === 'en_US' && !disableGiftAddressForm;
      $scope.userPrefIsSigningUp = userPrefIsSigningUp;
      $scope.incompleteUserPrefSignUp =
        userPrefIsSigningUp && userPrefSkipEmailInput
          ? false
          : userPrefIsSigningUp && !userPrefValidForm;
      $scope.userPrefIsSaving = userPrefIsSaving;
      $scope.attestation = attestation;
      $scope.attestationData = attestationData;

      if (getCurrentStepFromUrl() === 'step-2') {
        a11yPageRedirection($scope.lang, $scope.lang['returns.step_2.header']);
      } else if (getCurrentStepFromUrl() === 'step-3') {
        a11yPageRedirection($scope.lang, $scope.lang['returns.step_3.step_3_header']);
      }
    };

    $scope.returnOptionsEnabled = returnOptionsEnabled;
    updateStoreState();

    if (!$scope.refundEligibility) {
      $scope.returnSubmitErrorMsg = $scope.lang['returns.step_3.refund_eligibility_error_alert'];
      $scope.displayReturnSubmitErrorMsg = true;
      store.dispatch(setLoading(false));
      $scope.isDisabledStep3 = true;
    }

    const unsubscribeFromReduxUpdates = store.subscribe(updateStoreState);
    $scope.$on('$destroy', unsubscribeFromReduxUpdates);

    $anchorScroll('top');
    $scope.product = retailerSettingsService.getProduct();
    $scope.retailer = retailerSettingsService.getName();
    $scope.exchangesEnabled = retailerSettingsService.getIsExchangeEnabled();
    returnReasonSidebar.actions.toggle();
    if ($scope.exchangesEnabled) {
      exchangeSidebar.actions.toggle();
    }
    const orderInfo = orderService.getOrder();

    // Reload page if no order data present
    if (!orderInfo.order_info) {
      $location.path(store.dispatch(getRedirectUrlPath()));
    }

    store.dispatch(updateStep2Complete(false));
    $rootScope.pageClass = 'step2-page';
    $scope.s = s;
    $scope.sButton = sButton;
    $scope.style = retailerSettingsService.getStyle();
    $scope.settings = retailerSettingsService.getSettings();
    store.dispatch(setLoading(false));
    $scope.agreementCheckboxEnabled = agreementCheckboxEnabled;
    $scope.agreementCheckboxOptions = agreementCheckboxOptions;
    $scope.isExchangesOnly = returnItemsService.isExchangesOnly();
    $scope.hasAnExchange = returnItemsService.hasAnExchange();
    $scope.returnSubmitErrorMsg = '';
    $scope.displayReturnSubmitErrorMsg = false;

    // Check conditions for any disclaimers, exchanges and gift returns
    if ($scope.agreementCheckboxEnabled) {
      retailerSettingsService.setRequiredConditions(
        'agreement_checkbox',
        $scope.selectedOptions.agreement_checkbox || false,
      );
    }

    if ($scope.hasAnExchange) {
      retailerSettingsService.setRequiredConditions(
        'exchange_disclaimer',
        $scope.selectedOptions.exchange || false,
      );
    } else {
      retailerSettingsService.deleteRequiredCondition('exchange_disclaimer');
    }

    const toggleGiftState = (isGift) => {
      store.dispatch(updateGiftFlag(isGift));
      if (isGift) {
        retailerSettingsService.setRequiredConditions('gift', false);
      } else {
        store.dispatch(updateGiftEmail(''));
        retailerSettingsService.setRequiredConditions('gift', true);
      }
    };

    const toggleNoRefundState = (selectedType) => {
      store.dispatch(selectRefundOption(selectedType));
    };

    toggleGiftState($scope.giftOrder);

    $scope.isDisabledStep3 = !retailerSettingsService.areAllConditionsChecked(store);

    $scope.returnItems = returnItemsService.getItems();
    $scope.returnItemsQty = $scope.returnItems.reduce(
      (sum, item) => sum + parseInt(item.return_qty, 10),
      0,
    );
    $scope.itemsSubtotal = returnFeeService.getReturnSubtotal();
    $scope.brand = retailerSettingsService.getBrand();
    $scope.hasSidebarAddressConfig =
      $scope.settings.sidebarShippingMethodConfig &&
      $scope.settings.sidebarShippingMethodConfig.length > 0;
    // Form config default exists
    // Check if it's used by determining if new settings exist
    $scope.hasFormAddressConfig =
      returnOptionsEnabled &&
      Object.values(returnOptionsMethods).some(
        ({ get_address: getAddress }) => getAddress === true && !$scope.carrierPickupEnabled,
      );
    $scope.hasBlindItems = Object.keys(blindReturnSidebarService.getBlindItems()).length > 0;
    $scope.onlyBlindItems = $scope.returnItems.filter((item) => !item.blindItem).length === 0;
    store.dispatch(setIsValidAddress(returnMethodSidebar.getAddressValidationState()));
    store.dispatch(setShowAddressOnStep3(retailerSettingsService.getShowReturnAddress()));
    store.dispatch(setShippingAddressValidation(false));

    const retailer = retailerSettingsService.getName();
    const order = returnItemsService.getReturnOrder();
    returnFeeService.setSelectedMethod({});
    let throttleSubmitButton = false;

    if ($scope.isShippingAddressEmpty) {
      store.dispatch(receiveShippingAddress({ ...$scope.defaultAddress }));
    }

    window.addEventListener(PICKUP_COMPLETE, () => {
      $scope.$apply();
    });

    // Return summary panel controls
    $scope.showSummary = false;

    const isValidateForm = (returnMethod) => {
      if (returnMethod && returnMethod.id && METHODS_WITHOUT_ADDRESS.includes(returnMethod.id)) {
        return false;
      }
      return (
        ($scope.returnOptionsEnabled && $scope.collectGiftAddress) ||
        ($scope.hasFormAddressConfig && returnMethod?.get_address)
      );
    };

    $scope.getShippingAmountDue = () => {
      let amountDue = 0;

      if ($scope.paymentsEnabled) {
        if ($scope.refundApiEnabled) {
          const { refunds: { selectedType, estimate: { methods = [] } = {} } = {} } =
            store.getState();
          const { debits: { shipping_fee: returnShippingFee = 0 } = {} } =
            methods.find((refundOption) => refundOption.type === selectedType) || {};
          amountDue = returnShippingFee;
        } else {
          const {
            return_cost: { return_shipping_fee: returnShippingFee = 0 },
          } = returnFeeService.getSelectedMethod();
          amountDue = returnShippingFee;
        }
      }

      store.dispatch(
        updatePaymentAmount({
          amountDue,
          formattedAmountDue: currencyService.formatPrice(amountDue),
        }),
      );
    };

    $scope.handleAuthorizationSuccess = (result) => {
      store
        .dispatch(receivePaymentAuthorization({ paymentAuthorization: { ...result } }))
        .then(() => {
          $scope.confirmReturnOrder();
        });
    };

    $scope.handleAuthorizationFailure = (result) => {
      const { error: { message } = {} } = result;
      $scope.paymentSubmissionError = message;
      $scope.$apply();
    };

    $scope.onStripeInit = (stripeRef, stripeCardNumberRef) => {
      $scope.stripeRef = stripeRef;
      $scope.stripeCardNumberRef = stripeCardNumberRef;
    };

    $scope.invokePayment = () => {
      store.dispatch(setLoading(true));
      $scope.paymentSubmissionError = null;
      $scope.stripeRef.createToken($scope.stripeCardNumberRef).then((result) => {
        const { error } = result;
        if (error) {
          store.dispatch(setLoading(false));
          $scope.handleAuthorizationFailure(result);
        } else {
          $scope.handleAuthorizationSuccess(result);
        }
      });
    };

    $scope.paymentIsDue = () =>
      $scope.paymentsEnabled === true && $scope.amountDue > 0 && $scope.paymentApiKey;

    // End of Return Payments

    $scope.navigateToStep = (num) => {
      $location.path(store.dispatch(getRedirectUrlPath(`step-${num}`)));
      $scope.$applyAsync();
    };

    $scope.handleReviewBack = () => {
      if (bypassSteps && bypassSteps.length > 0 && bypassSteps.includes('methods')) {
        $scope.navigateToStep(1);
      } else {
        $scope.navigateToStep(2);
      }
      $scope.$apply();
    };

    /**
     *
     * @param option - an object to add to the selectedOptions service
     * @param newValue - changed value. This property is for the checkbox type,
     * it is set to false when the checkbox is not checked.
     */
    $scope.listOnChange = (option, newValue) => {
      if (option.key === 'gift') {
        toggleGiftState(option.value);
      }
      if (option.key === 'refund_option') {
        toggleNoRefundState(option.value);
      }

      if (option.value !== newValue) {
        store.dispatch(removeSelectedOption(option.key));
      } else {
        store.dispatch(setSelectedOption(option));
      }
      $scope.isDisabledStep3 = !retailerSettingsService.areAllConditionsChecked(store);
    };

    $scope.onRefundOptionChange = (option, newValue) => {
      $scope.listOnChange(option, newValue);
      $scope.isDisabledStep3 = !retailerSettingsService.areAllConditionsChecked(store);
      $scope.$apply();
    };

    $scope.onIrreparableChange = (option, newValue) => {
      $scope.listOnChange(option, newValue);
      $scope.$apply();
    };

    $scope.onExchangeDisclaimerChange = (option, newValue) => {
      $scope.listOnChange(option, newValue);
      $scope.disableStep3(option);
      $scope.$apply();
    };

    $scope.onAgreementCheckboxChange = (option, newValue) => {
      $scope.listOnChange(option, newValue);
      $scope.disableStep3(option);
      $scope.$apply();
    };

    /**
     * Enables/disables proceeding to the next step depending from the options-list state.
     * @param option - an object with option data
     */
    $scope.disableStep3 = (option) => {
      const toggledOption = $scope.selectedOptions[option.key];
      retailerSettingsService.setRequiredConditions(option.key, !!toggledOption);
      $scope.isDisabledStep3 = !retailerSettingsService.areAllConditionsChecked(store);
    };

    $scope.giftReturnsOnChange = (emailValue) => {
      const isEmailValid = patternInputValidation(emailValue, EMAIL_ADDRESS_PATTERN);
      retailerSettingsService.setRequiredConditions('gift', isEmailValid);
      $scope.isDisabledStep3 = !retailerSettingsService.areAllConditionsChecked(store);
      store.dispatch(updateGiftEmail(emailValue));
    };

    // Get default method fee
    const getDefault = () => {
      $scope.returnMethods.forEach((method) => {
        if (method.default || generateMethodKey(method) === $scope.selectedMethodKey) {
          returnFeeService.getFee(method, $scope.toStep3);
        }
      });
    };

    // Check enabled methods
    const methodCount = () => {
      const count = $scope.returnMethods.filter(({ enabled }) => enabled).length;

      if ($scope.useGiftAddressSidebar && !$scope.isValidAddress) {
        $scope.returnMethods.forEach((method) => {
          method.default = false;
        });
      }

      // If only one method then set it as default
      if (count === 1) {
        $scope.returnMethods.forEach((method) => {
          method.default =
            method.get_address || $scope.useGiftAddressSidebar ? false : method.enabled;
        });
      }

      getDefault();
    };

    $scope.toStep2 = () => {
      $scope.navigateToStep(2);
      $scope.$apply();
    };

    $scope.toStep3 = async () => {
      const {
        page: { loading },
        returnOptions: { selectedOptionMethodKey },
      } = store.getState();
      if (loading) return;
      const hasValidLegacyUIAddress =
        $scope.hasSidebarAddressConfig &&
        $scope.selectedReturnOptionMethod &&
        $scope.selectedReturnOptionMethod.checkShipToAddress &&
        isAddressValid($scope.shipTo);
      const hasValidLocationsUIAddress =
        $scope.hasFormAddressConfig &&
        $scope.selectedReturnOptionMethod &&
        isAddressValid($scope.shipTo) &&
        !(displayFormIfExchangeIncluded && $scope.hasAnExchange);
      if (!$scope.collectGiftAddress && (hasValidLegacyUIAddress || hasValidLocationsUIAddress)) {
        store.dispatch(
          receiveShippingAddress(mapToCorrectShippingAddress($scope.shipTo, $scope.shipTo)),
        );
      } else if (isValidateForm($scope.selectedReturnOptionMethod)) {
        const isValid = await store.dispatch(validateAddress());
        if (!isValid) return;
        store.dispatch(receiveNotificationMessage(''));
      }
      if (returnOptionsEnabled && selectedOptionMethodKey) {
        returnFeeService.getFee($scope.selectedReturnOptionMethod, $scope.toStep3);
      }
      store.dispatch(setLoading(true));
      if (refundOptionEnabled || refundApiEnabled) {
        retailerSettingsService.setRequiredConditions(
          'selected-refund',
          !('noRefundSelected' in $scope) || $scope.hasRefundDefaults,
        );
      }
      store.dispatch(clearSelectedOptions());
      if ($scope.isConsolidated) {
        order.return_carrier =
          $scope.selectedStoreLocation.return_info.preferred_method_carrier.carrier;
        order.return_to_dc =
          $scope.selectedStoreLocation.return_info.preferred_method_carrier.return_to_dc;
      } else {
        const selectedMethod = returnFeeService.getSelectedMethod();
        order.return_carrier = selectedMethod.carrier;
        order.return_to_dc = selectedMethod.return_to_dc;
      }
      order.return_override_code = orderService.getOrderOverrideCode();

      if ($scope.refundOptionEnabled) {
        store.dispatch(setDefaultOptions($scope.settings.refund_option));
      }
      store.dispatch(setDefaultOptions($scope.settings.irreparable_option));
      store.dispatch(setDefaultOptions(agreementCheckbox));

      if ($scope.exchangesEnabled) {
        store.dispatch(
          setDefaultOptions({ options: [{ default: 'false', key: 'exchange_disclaimer' }] }),
        );
      }

      if (!throttleSubmitButton) {
        orderService.setConfirmOrder(order);

        if (unevenExchanges) {
          store.dispatch(calculateCart(order)).then(() => {
            $scope.navigateToStep(3);
          });
        } else if (refundApiEnabled) {
          store.dispatch(getRefundEstimation(order)).then(() => {
            if (returnOptionsEnabled) {
              returnFeeService.getFee($scope.selectedReturnOptionMethod, $scope.toStep3);
            }
            $scope.getShippingAmountDue();
            $scope.navigateToStep(3);
          });
        } else {
          $scope.getShippingAmountDue();
          $scope.navigateToStep(3);
        }
      }

      $scope.isDisabledStep3 = !retailerSettingsService.areAllConditionsChecked(store);
    };

    if (bypassSteps && bypassSteps.length > 0 && bypassSteps.includes('methods')) {
      $scope.toStep3();
      returnFeeService.calculateRefund($scope.toStep3);
      returnItemsService.updateCartActions();
      store.dispatch(setLoading(false));
    }

    const returnStatus = () => {
      const { page: { allStepsComplete } = {} } = store.getState();

      if (allStepsComplete) {
        $location.path(store.dispatch(getRedirectUrlPath()));
      }
    };

    if (!$scope.refundEligibility) {
      $scope.returnSubmitErrorMsg = $scope.lang['returns.step_3.refund_eligibility_error_alert'];
      $scope.displayReturnSubmitErrorMsg = true;
      $scope.isDisabledStep3 = true;
    } else {
      $scope.returnSubmitErrorMsg = '';
      $scope.displayReturnSubmitErrorMsg = false;
      $scope.isDisabledStep3 = !retailerSettingsService.areAllConditionsChecked(store);
    }

    $scope.confirmReturnOrder = () => {
      const { tooltip } = store.getState();

      store.dispatch(setLoading(true));
      if (tooltip.returnPostErrorTooltip) {
        store.dispatch(toggleTooltip('returnPostErrorTooltip'));
      }

      if (!$scope.refundEligibility && !($scope.refundApiEnabled && allowOnlyPositiveRefunds)) {
        $scope.returnSubmitErrorMsg = $scope.lang['returns.step_3.refund_eligibility_error_alert'];
        $scope.displayReturnSubmitErrorMsg = true;
        store.dispatch(setLoading(false));
        $scope.isDisabledStep3 = true;
        return;
      }

      extendOrder({
        estimatedRefund: returnFeeService.getEstimatedRefund(),
      });

      if ($scope.giftOrder) {
        returnItemsService.putGift({ checkbox: true, email: $scope.giftReturnsEmail });
      }

      const savedReturn = orderService.getConfirmOrder();

      // The onSubmitRedirectUrl will be enabled or not in the settings,
      // depanding on the product (repairs or returns).
      // For REPAIRS only the onSubmitRedirectUrl should have a key,
      // so we can get the actual url from the response
      const onSubmitRedirectUrl =
        $scope.settings.onSubmitRedirect && $scope.settings.onSubmitRedirect.href;
      postReturnService
        .submitReturn(savedReturn)
        .then((response) => {
          if (
            response.data.error_response &&
            response.data.error_response.error_code === 'returns.submit.async'
          ) {
            $location.path(store.dispatch(getRedirectUrlPath('step-async-label')));
            return response;
          }
          const urlLocation = response.data[onSubmitRedirectUrl];
          if (onSubmitRedirectUrl && urlLocation) {
            store.dispatch(setLoading(false));
            window.location.href = urlLocation;
          } else {
            $location.path(store.dispatch(getRedirectUrlPath('step-4')));
          }
        })
        .catch((error) => {
          const { tooltip: { returnPostErrorTooltip } = {} } = store.getState();
          store.dispatch(setLoading(false));
          if ($scope.paymentSubmissionError === null && !returnPostErrorTooltip) {
            store.dispatch(
              toggleTooltip(
                'returnPostErrorTooltip',
                ERRORS_WITH_CUSTOM_MESSAGES.includes(error.message) 
                  ? $scope.lang[`returns.step_3.submit_errors.${error.message}`]
                  : null
              )
            );
          }
        });
    };

    const invokeExchangePaymentAuth = () => {
      const {
        unevenExchanges: { calculatedCart: { payment_client_secret: clientSecret } = {} } = {},
      } = store.getState();
      $scope.paymentSubmissionError = null;
      $scope.stripeRef
        .confirmCardPayment(clientSecret, {
          payment_method: {
            card: $scope.stripeCardNumberRef,
          },
        })
        .then((result) => {
          const { error } = result;
          if (error) {
            store.dispatch(setLoading(false));
            $scope.handleAuthorizationFailure(result);
          } else {
            store.dispatch(receiveUnevenExchangePaymentAuth(result.id)).then(() => {
              $scope.confirmReturnOrder();
            });
          }
        });
    };

    $scope.processReturn = () => {
      const {
        returnItems: { cartActions = [] },
        unevenExchanges: { calculatedCart, isPaymentDue },
      } = store.getState();
      if ($scope.paymentIsDue()) {
        $scope.invokePayment();
      } else if ($scope.userPrefIsSigningUp && !$scope.incompleteUserPrefSignUp) {
        store.dispatch(saveUserPreferences()).then((saveState) => {
          if (saveState !== EMAIL_MISMATCH) {
            $scope.confirmReturnOrder();
          }
        });
      } else if (claimsEnabled) {
        const isClaim =
          cartActions.length > 0 && cartActions?.every((action) => action === ActionTypes.Claim);
        try {
          extendOrder();
        } catch (e) {
          console.error(e);
          store.dispatch(
            toggleTooltip(isClaim ? 'claimPostErrorTooltip' : 'returnPostErrorTooltip'),
          );
          return;
        }
        submitCart(orderService.getConfirmOrder())
          .then((data) => {
            const actionType = data?.actions?.[0]?.action_type;
            const submission = data?.actions?.[0]?.action_details?.[0];
            if (!submission) throw new Error('Submit failed');
            if (actionType === ActionTypes.Return || actionType === ActionTypes.Exchange) {
              const returnInfo = processReturnExchange(submission);
              store.dispatch(
                receiveReturnSubmission({
                  return_process_info: returnInfo,
                  error_response: {},
                }),
              );
              postReturnService.setReturnInfo(returnInfo);
            }
            $location.path(store.dispatch(getRedirectUrlPath('step-4')));
          })
          .catch((err) => {
            console.log(err);
            const { tooltip: { claimPostErrorTooltip, returnPostErrorTooltip } = {} } =
              store.getState();
            if ($scope.paymentSubmissionError === null && isClaim && !claimPostErrorTooltip) {
              store.dispatch(toggleTooltip('claimPostErrorTooltip'));
            } else if (
              $scope.paymentSubmissionError === null &&
              !isClaim &&
              !returnPostErrorTooltip
            ) {
              store.dispatch(toggleTooltip('returnPostErrorTooltip'));
            }
          });
      } else if (unevenExchanges && calculatedCart) {
        store.dispatch(setLoading(true));
        store.dispatch(createDraftOrder()).then(() => {
          if (isPaymentDue) {
            invokeExchangePaymentAuth();
          } else {
            $scope.confirmReturnOrder();
          }
        });
      } else {
        $scope.confirmReturnOrder();
      }
    };

    returnStatus();
    methodCount();
  },
]);
